import { TIMEZONE_OPTION } from "@/constants/Timezone";
import { validations } from "@/validations/zoom_meeting";
import {
  genWeeklyRepeatOn,
  JOIN_BEFORE_HOST,
  MEETING_TYPE,
  REPEAT_OPTIONS,
  TYPE_GUEST
} from "../ultils";
const dataOpts = {
  data() {
    const defaultFormCfg = () => {
      return {
        title: "",
        description: "",
        password: "",
        zoom_meeting_type: MEETING_TYPE.schedule,
        duration: null,
        timezone: "",
        type_guest: TYPE_GUEST.class,
        from_time: "",
        student_uuid: [],
        host_uuid: null,
        student_attendance: false,
        notification_before: 0,
        join_before_host: false,
        participant_join_before_host: JOIN_BEFORE_HOST.anytime
      };
    };
    const defaultCalendar = {
      repeat: "weekly",
      start_date_time: "",
      from_time: null,
      duration: "",
      start: null,
      end: null
    };
    defaultCalendar.repeat_on = genWeeklyRepeatOn(
      defaultCalendar.start,
      defaultCalendar
    );
    return {
      valueCheckbox: false,
      joinBeforeHost: JOIN_BEFORE_HOST,
      typeGuest: TYPE_GUEST,
      assignedStudentInformation: [],
      timeZoneOpts: TIMEZONE_OPTION,
      form: this.formProps || defaultFormCfg(),
      defaultFormCfg: defaultFormCfg(),
      calendar: defaultCalendar,
      meetingType: MEETING_TYPE,
      serverValidations: {},
      zoomValidation: validations,
      repeatOpts: REPEAT_OPTIONS,
      delayTime: "",
      listGuestOptions: [],
      isCreate: false,
      isCreateStart: false,
      isCreateEnd: false,
      isCreateRepeatOn: false,
      isGenerateSubmit: false,
      isUpdateSubmit: false,
      memorizedSelected: [],
      cpnKeySelectList: null,
      cpnKeyDatetime: null,
      hostVideo: {
        label: "zoom_meeting.host_video",
        value: "",
        options: [],
        displayValue: "",
        fields: {
          text: "full_name_email",
          value: "uuid"
        },
        refetchOptions: (selectedValue, queryObj) => {
          return this.getHostOpts(selectedValue, queryObj);
        }
      }
    };
  },
  computed: {
    timezoneDisplay() {
      return this.form.timezone;
    },
    isScheduleMeeting() {
      return this.form.zoom_meeting_type === MEETING_TYPE.schedule;
    },
    typeGuestIsClass() {
      return this.form.type_guest === TYPE_GUEST.class;
    },
    labelSelect() {
      return this.typeGuestIsClass
        ? "zoom_meeting.class_name"
        : "zoom_meeting.search_by";
    }
  },
  watch: {
    "form.host_uuid": function(newVal) {
      if (!this.hostVideo.options.length) return;
      this.hostVideo.host_ui_id = this.hostVideo.options.find(
        item => item.uuid === newVal
      )?.host_id;
    },
    "calendar.repeat": function(newVal) {
      if (this.isCreateRepeatOn) return;
      this.calendar.repeat_on = genWeeklyRepeatOn(this.calendar.start, {
        end: this.calendar.end
      });
    },
    "form.type_guest": function() {
      if (this.isCreate) return;
      this.memorizedSelected = [];
      this.listGuestOptions = [];
    },
    "form.name": function() {
      this.serverValidations.name && delete this.serverValidations.name;
    },
    "calendar.start": function(newStart) {
      if (this.isCreateStart) return;
      if (!newStart) {
        this.calendar.repeat_on = [];
        return;
      }
      this.calendar.repeat_on = genWeeklyRepeatOn(newStart, {
        end: this.calendar.end
      });
      this.isCreateStart = false;
    },
    "calendar.end": function(newEndDate) {
      if (this.isCreateEnd) return;
      if (!newEndDate) {
        this.calendar.repeat_on = [];
        return;
      }
      this.calendar.repeat_on = genWeeklyRepeatOn(this.calendar.start, {
        end: newEndDate
      });
      this.isCreateEnd = false;
    }
  }
};

export { dataOpts };
